import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import HistoryPage from '@/pages/Shifts/HistoryPage';
import { GroupsEnum } from '@/types/users';
import { RoleRoute } from './RouteGuards';

export const ShiftsPage = React.lazy(() => import('@/pages/Shifts/ShiftsPage'));
const ScannerPage = React.lazy(() => import('@/pages/Shifts/ScannerPage'));
const AcceptStorePage = React.lazy(() => import('@/pages/Shifts/AcceptStorePage'));
const PhotoPage = React.lazy(() => import('@/pages/Shifts/PhotoPage'));
const MapPage = React.lazy(() => import('@/pages/Shifts/MapPage'));

const employeeRoute = (path: string, element: React.ReactNode) => (
  <Route
    key={path}
    path={path}
    element={
      <RoleRoute groups={[GroupsEnum.CLIENT]} mobileOnly>
        {element}
      </RoleRoute>
    }
  />
);

const routeDefinitions = [
  { path: 'shifts', element: <Navigate to="/" replace /> },
  { path: 'history', element: <HistoryPage /> },
  { path: 'scanner/:mode', element: <ScannerPage /> },
  { path: 'scanner/:mode/accept/:code', element: <AcceptStorePage /> },
  { path: 'scanner/accept/:code', element: <AcceptStorePage /> },
  { path: 'photo/:code', element: <PhotoPage /> },
  { path: 'maps/:code', element: <MapPage /> },
];

export const employeeRoutePaths = routeDefinitions.map(({ path }) => path);
export const employeeRoutes = routeDefinitions.map(({ path, element }) =>
  employeeRoute(path, element),
);
